import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import classnames from 'classnames';
import LocationOn from '@material-ui/icons/LocationOn';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import IconButton from '@material-ui/core/IconButton';
import VpnKey from '@material-ui/icons/VpnKey';
import format from 'date-fns/format';
import differenceInDays from 'date-fns/differenceInDays';

const styles = theme => ({
  box: {
    display: 'flex',
    position: 'relative',
    minWidth: 200,
    width: 200,
    minHeight: 160,
    height: 150,
    margin: 10,
    transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
    borderRadius: 5,
    cursor: 'pointer',
    border: 1.5,
    borderStyle: 'solid',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: 20,
  },
  active: {
    color: '#fff',
    backgroundColor: '#4A90E2',
    boxShadow:
      '0px 0px 5px rgba(126, 211, 33, 0.7), 0px 0px 5px rgba(126, 211, 33,0.9)',
    borderColor: 'rgba(126, 211, 33, 0.7)',
  },
  inactive: {
    color: '#000',
    backgroundColor: '#fff',
    boxShadow: '0px 0px 5px rgba(236, 94, 60, 0.7)',
    borderColor: 'rgba(236, 94, 60, 0.7)',
  },
  campaignNameActive: {
    color: '#fff',
    fontSize: '1em',
  },
  campaignNameInactive: {
    color: '#000',
    fontSize: '1em',
  },
  campaignBrandActive: {
    color: '#fff',
    fontSize: '0.8em',
  },
  campaignBrandInactive: {
    color: '#000',
    fontSize: '0.8em',
  },
  campaignDatesActive: {
    marginTop: 5,
    color: '#ddd',
    fontSize: '0.7em',
  },
  campaignDatesInactive: {
    marginTop: 5,
    color: '#555',
    fontSize: '0.7em',
  },
  campaignMediaTypeActive: {
    color: '#ddd',
    fontSize: '0.7em',
  },
  campaignMediaTypeInactive: {
    color: '#555',
    fontSize: '0.7em',
  },
  campaignLocationContainer: {
    color: '#ddd',
    marginTop: 3,
    display: 'flex',
    alignItems: 'center',
  },
  campaignLocationIcon: {
    fontSize: '1em',
  },
  campaignLocationTextActive: {
    fontSize: '.7em',
    color: '#ddd',
  },
  campaignLocationTextInactive: {
    fontSize: '.7em',
    color: '#555',
  },
  iconContainer: {
    position: 'absolute',
    right: 5,
    bottom: 5,
    display: 'flex',
  },
  iconButton: {
    width: 40,
    height: 40,
  },
  icon: {
    color: '#ffffff',
  },
});

const Campaign = ({
  classes,
  campaign,
  onClick,
  showCampaignInfo,
  openKeyManagement,
}) => {
  return (
    <div
      className={classnames(
        classes.box,
        classes[campaign.active ? 'active' : 'inactive']
      )}
      onClick={onClick}
    >
      <div
        className={
          classes[
            campaign.active ? 'campaignNameActive' : 'campaignNameInactive'
          ]
        }
      >
        {campaign.name}
      </div>

      <div
        className={
          classes[
            campaign.active ? 'campaignBrandActive' : 'campaignBrandInactive'
          ]
        }
      >
        {campaign.brand}
      </div>

      <div
        className={
          classes[
            campaign.active ? 'campaignDatesActive' : 'campaignDatesInactive'
          ]
        }
      >
        {`${format(campaign.start, 'MMM DD, YY')} - ${format(
          campaign.stop,
          'MMM DD, YY'
        )} (${differenceInDays(campaign.stop, campaign.start)} days)`}
      </div>

      <div
        className={
          classes[
            campaign.active
              ? 'campaignMediaTypeActive'
              : 'campaignMediaTypeInactive'
          ]
        }
      >
        {campaign.mediaType.join(', ')}
      </div>

      {campaign.geography && (
        <div className={classes.campaignLocationContainer}>
          <LocationOn className={classes.campaignLocationIcon} />
          <div
            className={
              classes[
                campaign.active
                  ? 'campaignLocationTextActive'
                  : 'campaignLocationTextInactive'
              ]
            }
          >
            {campaign.geography}
          </div>
        </div>
      )}

      <div className={classes.iconContainer}>
        <IconButton
          className={classes.iconButton}
          onClick={event => {
            openKeyManagement(campaign);
            event.stopPropagation();
          }}
        >
          <VpnKey className={classes.icon} />
        </IconButton>
        <IconButton
          className={classes.iconButton}
          onClick={event => {
            showCampaignInfo(campaign);
            event.stopPropagation();
          }}
        >
          <InfoOutlined className={classes.icon} />
        </IconButton>
      </div>
    </div>
  );
};

Campaign.propTypes = {
  classes: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(Campaign);
